module.exports = __webpack_public_path__ + "static/img/empty-folder.a8fcf51e.svg";